export default __webpack_public_path__ + "static/media/layers.4adc59cc.png";